module.exports = __webpack_public_path__ + "static/media/cidekic_logo.776e2efc.svg";